import MessageHelpers from '@/helpers/MessageHelpers';

// Ajout du fichier dans le DOM du formulaire
export default {
  data() {
    return {
      messageInitial: null,
    };
  },
  methods: {
    mixinMessageErreur_getMessage(message, key = null, idMessage = false, variables = null) {
      if (message && message[0].length) {
        this.messageInitial = message;
        if (typeof message == 'string') {
          if (message.startsWith('MSG')) {
            // Obtient messages de la page ou de l'app
            MessageHelpers.obtenirMessage(message, this.$root)
              .then((response) => {
                if (idMessage) {
                  this.mixinMessageErreur_remplirMessage(
                    this.modifierMessage(response.msgDetail),
                    idMessage
                  );
                } else {
                  // Formattage des messages (String) en provenance de Magnolia avec remplacement des clés, variables
                  this.formatterMessage(response.msgDetail, key, variables);
                  if (key && this.messageType) {
                    this.messageType[key] = response.msgType;
                  } else {
                    this.messageType = response.msgType;
                  }
                }
              })
              .catch(() => {
                console.log('erreur de récupération');
                // TODO:
              });
          } else {
            // Formattage des messages (String) ne proveannt pas de Magnolia avec remplacement des clés, variables
            this.formatterMessage(message, key);
          }
        } else if (typeof message === 'object') {
          if (message[0].startsWith('MSG')) {
            // Obtient messages de la page ou de l'app
            MessageHelpers.obtenirMessage(message[0], this.$root)
              .then((response) => {
                // Formattage des messages (Objet) en provenance de Magnolia avec remplacement des clés, variables
                this.formatterObjetMessage(message, key);
              })
              .catch(() => {
                // TODO:
              });
          } else {
            // Formattage des messages (Objet) en provenance de Magnolia avec remplacement des clés, variables
            this.formatterObjetMessage(message, key);
          }
        }
      }
    },
    // Messages provenant de l'app message pouvant contenir des clés (exemple: '{key}').
    // On remplaces les clés avec les valeurs contenues dans l'objet key
    // La méthode est utilisé pour changer les codes des messages du téléversement
    remplacerCles(message) {
      for (let i = 1; i < this.messageInitial.length; i++) {
        const object = this.messageInitial[i];
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in object) {
          message = message.replace(`{${key}}`, object[key]);
        }
      }

      return this.modifierMessage(message);
    },
    // Messages provenant de l'app message pouvant contenir des variables (exemple: '{{valeur}}').
    // On remplaces les variables avec les valeurs contenues dans l'objet variables
    // La méthode est utilisée pour modifier les variables dans les messages définis dans Magnolia
    remplacerVariables(message) {
      const entity = Object.fromEntries(Object.entries(this.variables));
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const property in entity) {
        message = message.replace(`{{${property}}}`, entity[property]);
      }

      return this.modifierMessage(message);
    },
    // Messages provenant de l'app message sont encapsulées dans des spans.
    // Changement des balises pour uniformiser le padding des affichages
    modifierMessage(message) {
      if (message.includes('<p>')) {
        message = message.replace('<p>', '<span>');
        message = message.replace('</p>', '</span>');
      }
      return message;
    },

    // Formattage des messages type String en provenance de Magnolia avec remplacement des clés, variables
    formatterMessage(message, key = null, variables = null) {
      if (key) {
        this.messageErreur[key] = this.remplacerCles(message);
      } else if (variables) {
        this.messageErreur = this.remplacerVariables(message);
      } else {
        this.messageErreur = this.modifierMessage(message);
      }
    },

    // Formattage des messages type Objet en provenance de Magnolia avec remplacement des clés, variables
    formatterObjetMessage(message, key = null) {
      if (key) {
        this.messageErreur[key] = this.remplacerCles(message);
        if (this.messageType) {
          this.messageType[key] = message.msgType;
        }
      } else {
        this.messageErreur = this.modifierMessage(message);
        this.messageType = message.msgType;
      }
    },

    // Message ne s'ajoute pas au load de la page quand on ajoute le message par v-html
    // Obligatoire pour ne pas avoir des messages vides.
    // TODO: trouver un moyen de remplir les messages de façon plus Vue.js
    mixinMessageErreur_remplirMessage(message, idMessage) {
      const liTable = document.querySelectorAll(`#${idMessage}`);
      if (liTable[0] && liTable[0].innerHTML == '' && !message.includes('MSG')) {
        for (let i = 0; i < liTable.length; i++) {
          liTable[i].innerHTML = message;
        }
      }
    },
  },
};
